import { render, staticRenderFns } from "./lookDetails.vue?vue&type=template&id=498fd284&scoped=true&"
import script from "./lookDetails.vue?vue&type=script&lang=js&"
export * from "./lookDetails.vue?vue&type=script&lang=js&"
import style0 from "./lookDetails.vue?vue&type=style&index=0&id=498fd284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498fd284",
  null
  
)

export default component.exports